<template>
  <div id="calendar-week-full">
    <div class="month-full">
      <div class="full-width week-full-header">
        <div class="days-of-week" v-for="(day, val) in days_of_week">{{$t(day) | minDayOfWeek}}</div>
      </div>
      <div class="full-width week-full-row">
        <div v-for="date in week"  :class="'days-of-month ' + (date.format('YYYY-MM-DD') == $moment(full_date).format('YYYY-MM-DD') ? ' choosed_date' : '') " @click="setFullDate(date)">
          <div v-if="date != null"
               :class="'text-center selected-date '
               + (date.format('YYYY-MM-DD') == $moment().format('YYYY-MM-DD') && today ? 'border-radius-50per' : '')"
               :style="date.format('YYYY-MM-DD') == $moment().format('YYYY-MM-DD') && today ? 'background: ' + todayColor + '; color: #fff;' : ''"
          >
            {{date.format('D')}}
          </div>
          <div v-for="(value, i) in dates[$moment(date).format('YYYYMMDD')].data" :key="i.label">
            <div v-for="(item) in value" :key="item.id"
                 v-if="dates[$moment(date).format('YYYYMMDD')] != null"
                 :class="'event '
               + (dates[$moment(date).subtract(1, 'day').format('YYYYMMDD')] == null || dates[$moment(date).subtract(1, 'day').format('YYYYMMDD')][item.type] == null ? ' non--before ' : '')
               + (dates[$moment(date).add(1, 'day').format('YYYYMMDD')] == null || dates[$moment(date).add(1, 'day').format('YYYYMMDD')][item.type] == null ? ' non--after ' : '')"
                 :style="'background: ' + (title[item.type].color)"
            >
              <span v-if="(i == 3 || i == 4)" v-for="data in dates[$moment(date).format('YYYYMMDD')][item.type]">
                {{$t('calendar.' + item.type)}}
              </span>
                <span v-if="i != 3 && i != 4 && d.opening == item.value.opening" v-for="d in dates[$moment(date).format('YYYYMMDD')][item.type]">
                <span v-if="d.name != '' && d.name != null">{{d.name}}</span>
                <span v-else>{{$t('calendar.' + item.type)}}</span>
                ({{d.opening | minTime}} - {{d.closing | minTime}})
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .week-full-header {
    display: flex;
    height: 50px;
    border-bottom: 1px solid #e3e4e9 !important;
  }
  .days-of-week {
    flex: 1;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    padding-bottom: 10px;
    color: #0091ff;
    height: 50px;
    line-height: 50px;
  }
  .week-full-row {
    display: flex;
  }
  .week-full-row .days-of-month:first-child {
    border-left: 1px solid #e3e4e9 !important;
  }
  .days-of-month {
    flex: 1;
    text-align: center;
    font-size: 12px;
    padding-top: 0px;
    padding-bottom: 10px;
    font-weight: 600;
    cursor: pointer;
    min-height: 550px;
    border-bottom: 1px solid #e3e4e9 !important;
    border-right: 1px solid #e3e4e9 !important;
  }
  .text-disable {
    color: #c2c4c6;
  }
  .border-radius-50per {
    border-radius: 50%;
  }
  .bg-main {
    background: #0091ff;
    color: #fff !important;
  }
  .selected-date {
    padding: 2px 0px;
    max-width: 100%;
    width: 22px;
    margin-left: auto;
    margin-right: auto;
  }
  .event {
    width: 100%;
    margin-top: 3px;
    margin-bottom: 3px;
    text-align: left;
    padding-left: 5px;
    padding-right: 5px;
    color: #fff;
    font-size: 10px;
    /*white-space: pre-line;*/
    overflow: hidden;
    height: 15px;
  }
  .event.non-before {
    width: calc(100% - 5px);
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    margin-left: 5px;
  }
  .event.non-after {
    width: calc(100% - 5px);
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    margin-right: 5px;
  }
  .event.non-before.non-after {
    width: calc(100% - 10px);
  }
  .choosed_date {
    background-color: #d1d4d7;
  }
</style>
<script>
export default {
  name: 'CalendarWeekFull',
  props: {
    events: {
      type: Array,
      required: false
    },
    full_date: {
      required: false
    },
    today: {
      default: false
    },
    todayColor: {
      default: '#0091ff'
    },
    data: {
      type: Object,
      required: false
    },
    title: {
      required: false
    }
  },
  data: function () {
    return {
      dates: {},
      week: [],
      days_of_week: {
        '0': 'common.sun',
        '1': 'common.mon',
        '2': 'common.tue',
        '3': 'common.wed',
        '4': 'common.thu',
        '5': 'common.fri',
        '6': 'common.sat'
      }
    }
  },
  methods: {
    createDateByWeek () {
      this.dates = {}
      this.week = []
      let currentDayOfWeek = this.$moment(this.full_date).format('e')

      for (let i = 0; i <= 6; i++) {
        let date = null
        if (currentDayOfWeek > i) {
          date = this.$moment(this.full_date).subtract(currentDayOfWeek - i, 'day')
        } else if (currentDayOfWeek == i) {
          date = this.$moment(this.full_date)
        } else if (currentDayOfWeek < i) {
          date = this.$moment(this.full_date).add(i - currentDayOfWeek, 'day')
        }
        this.week.push(date)
        this.dates[date.format('YYYYMMDD')] = {}
      }

      for (let i in this.data) {
        let items = this.data[i]
        for (let j in items) {
          let item = items[j]
          let d = null
          // Hard code for hut's day checking, need to improve
          if (typeof item == 'string') {
            d = this.$moment(item, 'YYYY-MM-DD')
          } else {
            d = this.$moment(item.date, 'YYYY-MM-DD')
          }

          if (this.dates[d.format('YYYYMMDD')] != null) {
            if (this.dates[d.format('YYYYMMDD')][i] == null) {
              this.dates[d.format('YYYYMMDD')][i] = []
            }
            this.dates[d.format('YYYYMMDD')][i].push(item)
          }
        }
      }

      for (let d in this.dates) {
        let item = {}
        let types = []
        for (let t in this.dates[d]) {
          types.push(t)
          switch (t) {
            case 'huts_day':
              item[3] = [{
                type: t,
                value: this.dates[d][t]
              }]
              break
            case 'public_holiday':
              item[4] = [{
                type: t,
                value: this.dates[d][t]
              }]
              break
            default:
              for (let i in this.dates[d][t]) {
                let key = this.$moment.duration(this.dates[d][t][i].opening).asSeconds()
                if (item[key] == null) {
                  item[key] = []
                }
                item[key].push({
                  type: t,
                  value: this.dates[d][t][i]
                })
              }
          }
        }

        this.dates[d].data = item
        this.dates[d].types = types
      }
    },
    setFullDate (date) {
      this.$emit('setFullDate', date)
      let newData = {}
      for (let i in this.dates[date.format('YYYYMMDD')]) {
        if (i != 'data' && i != 'types') {
          newData[i] = this.dates[date.format('YYYYMMDD')][i]
        }
      }
      this.$emit('dataChange', newData)
    }
  },
  filters: {
    minDayOfWeek: function (day) {
      return day.substr(0, 3).toUpperCase()
    },
    minTime: function (time) {
      return time.substr(0, 5).toUpperCase()
    }
  },
  created () {
    this.createDateByWeek()
    this.setFullDate(this.$moment(this.full_date))
  },
  watch: {
    full_date: function (val) {
      this.createDateByWeek()
    },
    data: {
      handler: function (after, before) {
        this.createDateByWeek()
        let newData = {}
        for (let i in this.dates[this.full_date.format('YYYYMMDD')]) {
          if (i != 'data' && i != 'types') {
            newData[i] = this.dates[this.full_date.format('YYYYMMDD')][i]
          }
        }
        this.$emit('dataChange', newData)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/CalendarWeekFull.vue